import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.edit-credit-card-item.presenters.EditCreditCardItemFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  // Exact Angular parity string — same toast as create (BHV-018).
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'The credit card item has been updated successfully.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to update the credit card item.',
  },
})
